import { type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { type AlgoliaRecord } from '../../../../algolia'

type LabelValuePair = {
  formattedMessage: ReactNode
  value: string
}

// eslint-disable-next-line max-statements -- the rule was disabled before a comment became required
export const productSearchResultItemFactsSwitcher = (
  item: AlgoliaRecord,
): LabelValuePair | null => {
  const { displayCode, ean, id, isbn, pzn, upid } = item

  const code = displayCode || pzn

  if (code && isbn) {
    return {
      formattedMessage: <FormattedMessage id="general.label.pznIsbn" />,
      value: `${code}/${isbn}`,
    }
  }

  if (code && ean) {
    return {
      formattedMessage: <FormattedMessage id="general.label.pznEan" />,
      value: `${code}/${ean}`,
    }
  }

  if (code) {
    return {
      formattedMessage: <FormattedMessage id="general.label.pzn" />,
      value: code,
    }
  }

  if (isbn) {
    return {
      formattedMessage: <FormattedMessage id="general.label.isbn" />,
      value: isbn,
    }
  }

  if (ean) {
    return {
      formattedMessage: <FormattedMessage id="general.label.ean" />,
      value: ean,
    }
  }

  if (upid) {
    return {
      formattedMessage: <FormattedMessage id="general.label.upid" />,
      value: upid,
    }
  }

  if (id) {
    return {
      formattedMessage: <FormattedMessage id="general.label.upid" />,
      value: id,
    }
  }

  return null
}
